import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { listRequisitions } from '../api/vendorApi';
import { VpSpinner, VpEmpty, VpStatusBadge, fmtDate } from '../components/VpUI';

const VendorRequisitions = () => {
	const navigate = useNavigate();
	const [loading, setLoading] = useState(true);
	const [rows, setRows] = useState<any[]>([]);
	const [error, setError] = useState('');

	useEffect(() => {
		(async () => {
			try {
				const data = await listRequisitions();
				setRows(Array.isArray(data) ? data : []);
			} catch (err: any) {
				setError(err?.apiMessage || 'Could not load requisitions.');
			} finally {
				setLoading(false);
			}
		})();
	}, []);

	if (loading) return <VpSpinner />;
	if (error) return <div className='vp-alert vp-alert-error'>{error}</div>;

	return (
		<div className='vp-card'>
			<div className='vp-card-head'>
				<h3>Assigned Requisitions</h3>
			</div>
			{rows.length === 0 ? (
				<VpEmpty icon='📋' text='No requisitions have been assigned to you yet.' />
			) : (
				<div className='vp-table-wrap'>
					<table className='vp-table'>
						<thead>
							<tr>
								<th>Requisition No</th>
								<th>Date</th>
								<th>Items</th>
								<th>Quotation</th>
								<th style={{ textAlign: 'right' }}>Action</th>
							</tr>
						</thead>
						<tbody>
							{rows.map((r) => (
								<tr key={r._id}>
									<td style={{ fontWeight: 600 }}>{r.requisition_no}</td>
									<td>{fmtDate(r.date || r.createdAt)}</td>
									<td>{r.products?.length ?? 0}</td>
									<td>
										{r.alreadyQuoted ? (
											<VpStatusBadge
												status={r.myQuotation?.quotation_status}
											/>
										) : (
											<span className='vp-badge vp-badge-neutral'>
												Not quoted
											</span>
										)}
									</td>
									<td style={{ textAlign: 'right' }}>
										{r.alreadyQuoted ? (
											<button
												type='button'
												className='vp-btn vp-btn-ghost vp-input-sm'
												onClick={() =>
													navigate(
														`/vendor-portal/quotations/${r.myQuotation?._id}`,
													)
												}>
												View quote
											</button>
										) : (
											<button
												type='button'
												className='vp-btn vp-btn-primary vp-input-sm'
												onClick={() =>
													navigate(`/vendor-portal/requisitions/${r._id}`)
												}>
												Submit quotation
											</button>
										)}
									</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
			)}
		</div>
	);
};

export default VendorRequisitions;
